import { Box } from "@mui/material";
import SearcherTable from "./components/SearcherTable";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_TRAININGS } from "../../Querys/querys";
import TableBits from "../TableBits/TableBits";
import UserField from "./components/UserField";
import FormatDateIngreso from "./components/FormatDateIngreso";
import MenuList from "./components/MenuList";
import columns from "./components/ColumnsTable";

const TrainingTable = () => {
  const [trainingList, setTrainingList] = useState([]);
  const [trainingListFilter, setTrainingListFilter] = useState<any[]>([]);
  const [getTraining, { data: training }] = useLazyQuery(
    GET_ALL_TRAININGS,
    {
      onError: (error) => {
        console.log("Error en la consulta", error);
      },
      fetchPolicy: "no-cache",
    }
  );
  const [paginationObj, setPaginationObj] = useState({
    rowsOfPage: 10,
    pageNumber: 0,
    searchTerm: "",
    order: "desc",
    orderBy: "FechaIngreso",
  });
  useEffect(() => {
    console.log(training);
    if (training && training.GET_ALL_TRAININGS) {
      setTrainingList(training.GET_ALL_TRAININGS);
      setTrainingListFilter(training.GET_ALL_TRAININGS);
    }
  }, [training]);
  return (
    <Box
      display="flex"
      flexDirection="column"
      p={2}
      style={{ backgroundColor: "white", borderRadius: "20px" }}
    >
      <Box p={1} pb={3} display="flex" flexDirection="row">
        <Box display="flex" justifyContent="flex-start">
          <SearcherTable
            label="Buscar por nombre / empresa / sede / area"
            initState={trainingList}
            setState={setTrainingListFilter}
            fields={["bussinesName", "enterprise", "campus", "area"]}
            customSearch={(searchTerm: string) => {
              getTraining({
                variables: {
                  rowsPerPage: paginationObj.rowsOfPage,
                  pageNumber: 0,
                  searchTerm,
                  order: paginationObj.order,
                  orderBy: paginationObj.orderBy,
                },
              });
              setPaginationObj({ ...paginationObj, pageNumber: 0, searchTerm });
            }}
          />
        </Box>
      </Box>
      <TableBits
        columns={columns}
        rows={trainingListFilter}
        components={[
          UserField,
          null,
          null,
          null,
          null,
          FormatDateIngreso,
          null,
          null,
        ]}
        componentOptions={MenuList}
        totalRecords={
          trainingListFilter?.length > 0 ? trainingListFilter[0]?.totalRows : 0
        }
        getData={async (paginationObj_) => {
          setPaginationObj((val) => ({
            ...val,
            rowsPerPage: paginationObj_.rowsOfPage,
            pageNumber: paginationObj_.pageNumber,
          }));
          getTraining({
            variables: {
              rowsPerPage: paginationObj_.rowsOfPage,
              pageNumber: paginationObj_.pageNumber,
              searchTerm: paginationObj.searchTerm,
              order: paginationObj.order,
              orderBy: paginationObj.orderBy,
            },
          });
        }}
        updatePaginationObj={(paginationObj_) => {
          setPaginationObj((val) => ({
            ...val,
            order: paginationObj_.order,
            orderBy: paginationObj_.orderBy,
          }));
          getTraining({
            variables: {
              rowsPerPage: paginationObj.rowsOfPage,
              pageNumber: paginationObj.pageNumber,
              searchTerm: paginationObj.searchTerm,
              order: paginationObj_.order,
              orderBy: paginationObj_.orderBy,
            },
          });
        }}
        customInitialOrderBy="FechaIngreso"
        customInitialOrder="desc"
        customRowsPerPage={10}
        updatePageNumber={paginationObj.pageNumber}
      />
    </Box>
  );
};
export default TrainingTable;
